import React from 'react';
import c from 'classnames';

import { SearchResults } from '@uncinc/react-searchkit';
import type { Results } from '@uncinc/react-searchkit/types';

import type {
  SearchAllContentHit,
  SearchAllContentArticleHit,
  SearchAllContentProjectHit,
  SearchAllContentVacancyHit,
  SearchAllContentProfileHit,
} from '../types';

import ArticleHit from './ArticleHit';
import PageHit from './PageHit';
import ProjectHit from './ProjectHit';
import VacancyHit from './VacancyHit';
import ProfileHit from './ProfileHit';

import './style.scss';

const RenderItem = (hit: SearchAllContentHit) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { content_type, profile_type } = hit;

  const type = profile_type?.[0] ? profile_type[0] : content_type[0];

  switch (type) {
    case 'article': {
      return <ArticleHit hit={hit as SearchAllContentArticleHit} />;
    }
    case 'project': {
      return <ProjectHit hit={hit as SearchAllContentProjectHit} />;
    }
    case 'vacancy': {
      return <VacancyHit hit={hit as SearchAllContentVacancyHit} />;
    }
    case 'default_profile': {
      return <ProfileHit hit={hit as SearchAllContentProfileHit} />;
    }
    case 'event':
    case 'homepage':
    case 'landing_page':
    case 'overview_page':
    case 'partner':
    case 'basic_page':
    default: {
      return <PageHit hit={hit as Exclude<SearchAllContentHit, SearchAllContentArticleHit | SearchAllContentProjectHit>} />;
    }
  }
};

const SearchAllContentResults: React.FC<Omit<Results, 'renderItem'>> = (props) => {
  const { className } = props;

  const classNames = c('SearchAllContent__Results', className);

  return (
    <SearchResults
      className={classNames}
      renderItem={RenderItem}
    />
  );
};

export default SearchAllContentResults;
